import React from "react";
import "./css/projects.css";

const locations = [
  {
    id: 1,
    name: "after school",
    description: "حضانت أطفال أطفال متخصصة في صحة الطفل.",
    image: "https://www.macschool.us/ourpages/auto/2018/11/7/42698022/AfterSchool%20Image.png", // Replace with actual image URLs
    mapEmbed: "https://maps.app.goo.gl/Cei1swjMzPJmDzpn8",
  },
  {
    id: 2,
    name: "centre medical folla",
    description: "عيادة تركز على نمو الطفل وعلم النفس.",
    image: "https://www.stonebridge.uk.com/blog/wp-content/uploads/2017/03/Why-Learn-More-About-Child-Psychology.jpg", // Replace with actual image URLs
    mapEmbed: "https://maps.app.goo.gl/8SGjLNBWa3jvDA1SA",
  },
  {
    id: 3,
    name: "School A",
    description: "testteets",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRF4sQx8sfVM24rzmOEXIAVhy0BBeEbEXCl-w&s", // Replace with actual image URLs
    mapEmbed: "https://goo.gl/maps/x6AoqXFd7JT2",
  },
  {
    id: 4,
    name: "School B",
    description: "la vie en rose",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRF4sQx8sfVM24rzmOEXIAVhy0BBeEbEXCl-w&s", // Replace with actual image URLs
    mapEmbed: "https://goo.gl/maps/x6AoqXFd7JT2",
  },
];

const Projects = () => {
  return (
    <div className="projects-container">
      <h2>مشاريع غادة سعداوي</h2>

      <div className="projects-grid">
        {locations.map((location) => (
          <div key={location.id} className="project-card">
            <img src={location.image} alt={location.name} className="project-image" />
            <div className="project-details">
              <h3>{location.name}</h3>
              <p>{location.description}</p>
              <button
                className="map-button"
                formTarget="_blank"
                onClick={() => window.open(location.mapEmbed, "_blank")}
              >
                عرض على الخريطة
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
